// src/firestore/cardPacks/index.ts

import * as path from '../path'

/**
 * Path to the `cardPacks` collection.
 *
 * `/cardPacks`
 */
export function collectionPath(): string {
  return 'cardPacks'
}

/**
 * Path to a specific card pack document.
 *
 * `/cardPacks/{packId}`
 */
export function documentPath(packId: string): string {
  return path.append(collectionPath(), packId)
}

/**
 * A Firestore document representing a card pack purchase.
 */
export type CardPack = {
  /** Unique identifier for the card pack (same as docId) */
  cardPackId: string
  /** Category of the cardPack */
  category?: string
  /** Collection of the cardPack */
  collection?: string
  /** Subcollection of the cardPack */
  subcollection?: string
  /** Total USDT price on this cardPack */
  price: number
  url: string
}
